import React, { useState, useEffect } from 'react';
import { Box, Fade } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoginForm from './LoginForm';
import SignUpForm from './SignUpForm';

const AuthContainer = () => {
  const [isLogin, setIsLogin] = useState(true);
  const navigate = useNavigate();
  const { currentUser, userProfile, loading } = useAuth();

  // Auto-redirect when user is authenticated
  useEffect(() => {
    console.log('AuthContainer useEffect triggered:', { currentUser, userProfile, loading });
    // Redirect if user is authenticated (don't wait for profile - ProtectedRoute will handle loading state)
    if (currentUser && !loading) {
      console.log('Attempting to navigate to home page');
      navigate('/', { replace: true });
    }
  }, [currentUser, loading, navigate]);

  const handleSwitchToSignUp = () => {
    setIsLogin(false);
  };

  const handleSwitchToLogin = () => {
    setIsLogin(true);
  };

  return (
    <Box sx={{ minHeight: '100vh' }}>
      <Fade in={isLogin} timeout={300}>
        <Box sx={{ display: isLogin ? 'block' : 'none' }}>
          <LoginForm onSwitchToSignUp={handleSwitchToSignUp} />
        </Box>
      </Fade>
      
      <Fade in={!isLogin} timeout={300}>
        <Box sx={{ display: !isLogin ? 'block' : 'none' }}>
          <SignUpForm onSwitchToLogin={handleSwitchToLogin} />
        </Box>
      </Fade>
    </Box>
  );
};

export default AuthContainer;
